module.exports = __webpack_public_path__ + "./assets/referral_exchange_logo.png";